// Mixin for common modal functionality
// Extracted from duplicate close() method in 6 modal components

export default {
  methods: {
    close() {
      this.closeAllModals()
    }
  }
}
